import React, { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../../context";
import {
  getMethodById,
  KLARNA,
  NETSEASY,
  SWEDBANKPAY,
  SWISH,
} from "../Payments/constants";
import CountdownContent from "../Cart/CountdownContent";
import Klarna from "./Klarna";
import NetsEasy from "./NetsEasy";
import Swish from "./Swish";
import { ActionIcon, Button, TextInput } from "@mantine/core";
import { createStyles } from "@mantine/emotion";
import autoAnimate from "@formkit/auto-animate";
import { commitPurchase } from "../Common/util";
import { useDispatch } from "react-redux";
import Modal from "react-modal";
import { RiCloseLargeFill } from "react-icons/ri";
import SwedbankPay from "./SwedbankPay";

const customStyles = {
  content: {
    height: "100%",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    marginTop: "1rem",
    transform: "translate(-50%, -50%)",
    width: "30rem",
  },
};
const useStyles = createStyles((theme) => ({
  close: {
    position: "absolute",
    top: "0.35rem",
    right: "0.35rem",
    color: "black",
    background: "transparent",
    "&:hover": {
      color: "black",
      background: "rgb(248, 249, 250)",
    },
  },

  onepageHeader: {
    textAlign: "center",
  },
  onepageCountdown: {
    paddingTop: "4px",
  },
  payWithSwish: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  cancelButton: {
    marginBottom: "1rem",
  },
}));

Modal.setAppElement("#root");

const OnePageContainer = (props) => {
  const { paymentMethods, sale } = props;
  const { classes } = useStyles();
  const { state } = useContext(AppContext);
  const { paymentMethodId, language, config } = state;
  const [itemExpired, setItemExpired] = useState(false);
  const [awaitingSwish, setAwaitingSwish] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [modalOpen, setModalOpen] = useState(true);
  const rdxDispatch = useDispatch();

  const scrollTargetRef = useRef(null);
  const parent = useRef(null);

  useEffect(() => {
    scrollTargetRef.current && scrollTargetRef.current.scrollIntoView();
  }, []);

  useEffect(() => {
    if (paymentMethodId === SWISH && state?.commitData?.identifier === "")
      setAwaitingSwish(true);
    else setAwaitingSwish(false);
  }, []);

  useEffect(() => {
    parent.current && autoAnimate(parent.current);
  }, [parent]);

  const submitSwish = () => {
    const selectedMethod = getMethodById(paymentMethodId);
    let commitData = state.commitData;
    commitData = { ...commitData, identifier: phoneNumber };
    commitPurchase(
      state.config?.apiUri,
      state.saleId,
      selectedMethod.supportsOnePage,
      props.setIsOnePageCheckoutActive,
      rdxDispatch,
      commitData,
      setAwaitingSwish
    );
  };

  const error = () => {
    if (!isFocused && phoneNumber.length >= 1 && phoneNumber.length < 10) {
      return language.Swish_Validation_Required;
    }
    return null;
  };

  if (!paymentMethodId) return null;

  return (
    <Modal
      isOpen={modalOpen}
      onRequestClose={() => window.location.reload()}
      contentLabel={language.Payment}
      style={customStyles}
      aria={{
        labelledby: "payment-title",
      }}
      shouldCloseOnOverlayClick={false}
    >
      <h2 id="payment-title">{language.Payment}</h2>
      <ActionIcon
        aria-label={language.Close}
        className={classes.close}
        onClick={() => window.location.reload()}
      >
        <RiCloseLargeFill />
      </ActionIcon>
      {awaitingSwish && (
        <div className={classes.payWithSwish} ref={parent}>
          <TextInput
            label={language.Swish_Phone_Label}
            description={language.Swish_Phone_Placeholder}
            onChange={(e) => setPhoneNumber(e.target.value)}
            type="number"
            required
            error={!isFocused && error()}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
          />
          <Button
            variant="primary"
            className="primaryButton"
            fullWidth
            size="md"
            onClick={() => submitSwish()}
            disabled={
              error() || phoneNumber.length === 0 || phoneNumber.length < 10
            }
          >
            {language.Swish_Pay_With}
          </Button>
        </div>
      )}
      {awaitingSwish === false && (
        <>
          <div
            ref={scrollTargetRef}
            id="onepage-scrolltarget"
            className={`${classes.onepageHeader} cart__onepage-header`}
          >
            <span className="cart__onepage-abortlink">
              <Button
                variant="primary"
                className={`${classes.cancelButton} primaryButton onepage_payment__cancel`}
                onClick={() => window.location.reload()}
              >
                {language.Cancel_Payment}
              </Button>
            </span>
            <div
              className={`${classes.onepageCountdown} onepage_payment__cart_countdown`}
            >
              <CountdownContent
                sale={sale}
                language={language}
                setItemExpired={setItemExpired}
              />
            </div>
          </div>
          {(() => {
            switch (paymentMethodId) {
              case SWISH:
                return <Swish paymentMethodId={paymentMethodId} />;

              case KLARNA:
                return (
                  <Klarna
                    paymentMethodId={paymentMethodId}
                    itemExpired={itemExpired}
                    setModalOpen={setModalOpen}
                  />
                );

              case NETSEASY:
                return (
                  <NetsEasy
                    paymentMethods={paymentMethods}
                    paymentMethodId={paymentMethodId}
                  />
                );
              case SWEDBANKPAY:
                return (
                  <SwedbankPay
                    paymentMethods={paymentMethods}
                    paymentMethodId={paymentMethodId}
                  />
                );

              default:
                return null;
            }
          })()}
        </>
      )}
    </Modal>
  );
};

export default OnePageContainer;
